export enum SavedFeatureServiceEvents {
    featureDeleted = 'featureDeleted'
}